// extracted by mini-css-extract-plugin
export default {"sectionTitle":"KP2Q3A4v147_LV0sAFqD"};